export const STRIPE_SUPPLEMENT = "STRIPE_SUPPLEMENT";